import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Layout from '@/components/layout/Layout';
import AccessibilityWidget from '@/components/AccessibilityWidget';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Industries from '@/pages/Industries';
import Work from '@/pages/Work';
import Articles from '@/pages/Articles';
import Contact from '@/pages/Contact';

function ScrollToTop() {
    const { pathname } = useLocation();
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    }, [pathname]);
    return null;
}

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                    <ScrollToTop />
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/industries" element={<Industries />} />
                            <Route path="/work" element={<Work />} />
                            <Route path="/articles" element={<Articles />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </Layout>
                    <AccessibilityWidget />
                </BrowserRouter>
            </div>
        </HelmetProvider>
    );
}

export default App;
